<template>
  <a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
    <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
      <a-row :gutter="24">
        <div class="hidden">
          <a-form-item label="id" name="id">
            <a-input v-model:value="form.id" />
          </a-form-item>
        </div>
        <a-col :span="12">
          <a-form-item label="营业执照(PDF格式)" name="licenceFile">
            <file-upload v-model:value="form.licenceFile" :size="800" :isPdf="true" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="企业法人身份证(正反面照片放到一张PDF中)" name="legalPersonCard">
            <file-upload v-model:value="form.legalPersonCard" :size="800" :isPdf="true" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="开户行许可证(PDF格式)" name="bankPermitFile">
            <file-upload v-model:value="form.bankPermitFile" :size="800" :isPdf="true" />
          </a-form-item>
        </a-col>
        <!-- <a-col :span="12">
          <a-form-item label="承诺书" name="legalPersonCard">
            <img-upload v-model:value="form.legalPersonCard" />
          </a-form-item>
        </a-col> -->
        <!-- <a-col :span="12">
          <a-form-item label="科技创新政策兑现汇总表" name="legalPersonCard">
            <img-upload v-model:value="form.legalPersonCard" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="阳泉高新技术产业开发区政策兑现事项申请表" name="legalPersonCard">
            <img-upload v-model:value="form.legalPersonCard" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="印证资料" name="legalPersonCard">
            <img-upload v-model:value="form.legalPersonCard" />
          </a-form-item>
        </a-col> -->
      </a-row>
      <!--可编辑区域 end-->
    </a-form>
  </a-modal>
</template>
<script>
import { formMixin } from "@/mixins";
import { sys_policy } from "@/api/policyService";
import dataCheck from "@/utils/dataCheck";

export default {
  name: "UserModal",
  components: {},
  mixins: [formMixin],
  data() {
    return {
      form: {
        id: null,
      },
      rules: {
        id: [],
        licenceFile: [dataCheck.required({})],
        legalPersonCard: [dataCheck.required({})],
        bankPermitFile: [dataCheck.required({})],
      },
      submitUrl: sys_policy.ziliaoUpdate
    }
  },
}
</script>
<style scoped lang="less"></style>
